import { render } from "./TreeParameterNode.vue?vue&type=template&id=0c08c6a2&scoped=true&ts=true"
import script from "./TreeParameterNode.vue?vue&type=script&lang=ts"
export * from "./TreeParameterNode.vue?vue&type=script&lang=ts"

import "./TreeParameterNode.vue?vue&type=style&index=0&id=0c08c6a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c08c6a2"]])

export default __exports__